export var checkActiveOption = function checkActiveOption(_ref) {
  var options = _ref.options,
    value = _ref.value,
    isMultiSelect = _ref.isMultiSelect;
  var isElemArray = function isElemArray(src) {
    return Array.isArray(src) === true;
  };
  var result = isMultiSelect ? [{
    id: ''
  }] : {
    id: ''
  };
  if (value && !isMultiSelect) {
    result = options.find(function (_ref2) {
      var id = _ref2.id;
      return id === value;
    }) || {
      id: ''
    };
    return result;
  }
  if (isElemArray(value) && value.length && isMultiSelect) {
    var filteredOptions = value.map(function (elem) {
      var newOption = options.filter(function (_ref3) {
        var id = _ref3.id;
        return elem === id;
      });
      return newOption[0];
    });
    if (filteredOptions[0] === undefined) {
      return [{
        id: ''
      }];
    }
    return filteredOptions;
  }
  return result;
};